import Login from "./Login";

export default function Dashboard() {
  return (
    <>
      <div className="mobile-pro">
        <div className="login">
          <img src="img/issue-icon-default.svg" />
          <h2 className="">Issuer</h2>
        </div>
      </div>
      <div className="col-content">
        <div className="notifications-container">
          <h2 className="welcome">Welcome to MyNextID Issuer</h2>
          <div className="login-container">
            <Login />
          </div>
        </div>
      </div>
    </>
  );
}
